import * as React from "react";
import { Link, styled } from "@mui/material";
import problemImage from "../../assets/clinic/problem.png";

//region [[ Styles ]]

const ErrorMessageView = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
});

const ErrorMessageBox = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: 40,
  gap: 20,
  lineHeight: 1.4,
  textAlign: "center",
  "& img": {
    maxWidth: "100%",
    width: "300px",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ErrorMessageProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ErrorMessage = ({ ...props }: ErrorMessageProps) => {
  return (
    <ErrorMessageView>
      <ErrorMessageBox>
        <img src={problemImage} alt={"We're having a problem"} />
        <div>
          Sorry, page could not be loaded
          <br />
          Please try reloading or contact us at{" "}
          <Link href="mailto:support@kahum.com">support@kahum.com</Link>
        </div>
      </ErrorMessageBox>
    </ErrorMessageView>
  );
};
